import { useTranslation } from 'react-i18next';
import { DesignSubPill } from './DesignSubPill';
import type { IDesignSubPillsProps } from './IDesignSubPillsProps';

/** Вкладки розділу проєктування під заголовком (прототип v4: «Усі · Проблеми · Ризики · Можливості», «Обов’язково · Бажано · Може бути»). */
export function DesignSubPills({ ws, rt, subs, active, onSelect }: IDesignSubPillsProps) {
  const { t } = useTranslation();
  return (
    <div className="dsg-pills" role="tablist" aria-label={t('modDesign.subsLabel')}>
      {subs.map((s) => <DesignSubPill key={s.sub.key} ws={ws} rt={rt} label={s.label} filter={s.filter} active={s.sub.key === active} onSelect={() => onSelect(s.sub.key)} />)}
    </div>
  );
}
